import { IconButton, Menu, MenuItem } from '@mui/material'
import { useState } from 'react'
import { IconMoreVert } from '../../icons/IconMoreVert'
import { openPlatformReportModal } from '../Modals'

type Props = {
  userId: number
}

export const UserProfileOverflowMenu = ({ userId }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleReport = () => {
    handleClose()
    openPlatformReportModal({
      targetType: 'user',
      targetId: userId,
      dialogTitle: 'Пожаловаться на пользователя',
    })
  }

  return (
    <>
      <IconButton
        aria-label="Дополнительные действия"
        onClick={handleOpen}
        sx={{ p: 0.5, flexShrink: 0 }}
      >
        <IconMoreVert fontSize="medium" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              width: 220,
              borderRadius: '12px',
              mt: 1,
            },
          },
        }}
      >
        <MenuItem onClick={handleReport} sx={{ fontSize: 14 }}>
          Пожаловаться
        </MenuItem>
      </Menu>
    </>
  )
}
